import { IconBase, IconComponent } from './BaseIcon';

export const AlignRight: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M4 2h26v2H4zM16 8.5h14v2H16zM2 15h28v2H2zM2 28h28v2H2zM10 21.5h20v2H10z" />
  </IconBase>
);
